export default [
  {
    path: "/clientes",
    component: () => import("@/views/clientes/Listar.vue"),
  },
  {
    path: "/clientes/crear",
    component: () => import("@/views/clientes/Crear.vue"),
  },
  {
    path: "/clientes/editar/:id",
    component: () => import("@/views/clientes/Editar.vue"),
  },
];
